// components/StyledContainer.ts
import { styled } from "@mui/material/styles";
import { Box, BoxProps } from "@mui/material";

interface ContainerBoxProps extends BoxProps {
  width?: string | number;
}

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "width",
})<ContainerBoxProps>(({ theme, width = "90%" }) => ({
  width,
  margin: "4.75rem auto 0px !important",
  display: "flex",
  gap: theme.spacing(8),
  flexDirection: "column",
  [theme.breakpoints.down("sm")]: {
    margin: "1.75rem auto 0px !important",
    gap: theme.spacing(8.5),
    padding: "0 1rem",
  },
}));

export default StyledContainer;
